<template>
    <div class="DshTitle">
        <slot name="prepend"></slot>
        <Icon
            class="DshTitle-icon"
            :custom="'bico-font ' + propsObj.icon"
            :color="propsObj.color"
            :size="propsObj.size || 14"
        />
        <slot>
            <span class="DshTitle-name">{{ propsObj.name || propsObj._name }}</span>
            <slot name="append"></slot>
        </slot>
    </div>
</template>

<script>
    export default {
        name: "DshTitle",
        props: {
            propsObj: {
                type: Object,
                default () {
                    return {};
                }
            }
        },
        data () {
            return {};
        },
        computed: {},
        created () {},
        methods: {}
    };
</script>



// WEBPACK FOOTER //
// node_modules/bri-vtools/src/components/small/DshTitle.vue